import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=ca0771e2&"
import script from "./formTextarea.js?vue&type=script&lang=js&"
export * from "./formTextarea.js?vue&type=script&lang=js&"
import style0 from "./formTextarea.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
